import { useRouteParams } from 'hooks';
import { getViewObject } from 'modules/scheduler/utils/schedulerUtil';

export const useGetViewObject = () => {
    const params = useRouteParams();

    return getViewObject(params);
};
